import { isArray } from 'lodash';

import { IFileDescriptionPayload, IFileUploadRequestPayload } from 'core/types';
import { getFormData, getQueryString } from 'core/utils';

import { partfinitiClient } from './partfinitiClient';

export const uploadFile = async ({
  file,
  queryParams,
}: {
  file: File | File[];
  queryParams: IFileUploadRequestPayload;
}) => {
  const filesToUpload = isArray(file) ? file : [file];

  return partfinitiClient.post(
    `/files/index/index?${getQueryString(queryParams)}`,
    getFormData({ files: filesToUpload })
  );
};

export const editFileDescription = async (payload: IFileDescriptionPayload) =>
  partfinitiClient.postForm('/files/file/edit-description', payload);
